export default __webpack_public_path__ + "cb3ee4378f7c3eaf8ef7a1ed3a6832ce.png";